import { ExternalLink } from "components/common/ExternalLink";
import { ReactElement } from "react";

export function Upload(): ReactElement {
  return (
    <div className="max-w-[800px] text-gray-700">
      <h1 className="text-lg font-bold mb-2">Zonenplan hochladen</h1>
      <p className="leading-relaxed">
        Beachten Sie, dass nach einem erfolgreichen Upload die Daten erst am
        folgenden Arbeitstag zur Weiterverarbeitung zur Verfügung stehen.
      </p>
      <p>
        <a
          href="https://rawi.lu.ch/-/media/RAWI/Dokumente/Downloads/geoinformation/Richtlinie_Upload_Zonenplanrevision_GIS.pdf"
          target="_blank"
          rel="noreferrer"
          className="mt-4 flex flex-row space-x-2 text-blue-400"
        >
          <span>Richtlinen Upload Zonenplan</span>
          <ExternalLink />
        </a>
      </p>
      <p>
        <a
          href="https://raumdatenpool.ch/Dokumente/RDP_Handbuch_Upload_GeoShop.pdf"
          target="_blank"
          rel="noreferrer"
          className="mt-4 flex flex-row space-x-2 text-blue-400"
        >
          <span>Handbuch Datenupload GeoShop</span>
          <ExternalLink />
        </a>
      </p>
    </div>
  );
}
